import { Divider } from "@mantine/core";
import { IconCircleArrowLeft } from "@tabler/icons-react";
import { Link } from "react-router";
import { ROUTES } from "../../../routes";
import { MenuItemContent } from "./MenuItemContent";

interface ModuleSwitchItemProps {
  isManagerPage?: boolean;
  isAdminDashboardPage?: boolean;
  userHasAnalyzerLicense?: boolean;
}

function ModuleSwitchItem({
  isManagerPage,
  isAdminDashboardPage,
  userHasAnalyzerLicense
}: ModuleSwitchItemProps) {
  let switchUrl: string, linkText: string;

  if (isManagerPage && userHasAnalyzerLicense) {
    switchUrl = ROUTES.analyzer;
    linkText = "Zum Analyzer";
  } else if (isAdminDashboardPage) {
    switchUrl = ROUTES.admin;
    linkText = "Zum Admin";
  } else {
    return null;
  }

  return (
    <div className="MenuItemStyle">
      <Divider mb={"sm"} />
      {!isAdminDashboardPage ? (
        <Link to={switchUrl}>
          <MenuItemContent icon={IconCircleArrowLeft} label={linkText} />
        </Link>
      ) : (
        <a href={switchUrl}>
          <MenuItemContent icon={IconCircleArrowLeft} label={linkText} />
        </a>
      )}
    </div>
  );
}

export { ModuleSwitchItem };
